// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientVitals_root__2vel1"};